// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/UserPlatform/index.css
// module id = 2462
// module chunks = 0